import CardBlock from '@/compositions/CardBlock'
import { GuidePageSection } from '@/shared/api-generated-types'
import React from 'react'
import * as styles from './style'

export interface Props extends Partial<GuidePageSection> {}

const GuideBlock = ({ ...props }: Props): JSX.Element | null => {
  if (!props.items?.length) return null

  const items = props.items?.map((item) => {
    return {
      ...item,
    }
  })

  return <CardBlock cardComponent="InstructorCard" theme="white" items={items} className={styles.content} />
}
export default React.memo(GuideBlock)
